import React from 'react';
import PropTypes from 'prop-types';
import { Button, Spinner } from 'react-bootstrap';
import './ActionToolbar.scss';

const ActionToolbar = ({
  onExportNotes,
  onEdit,
  exportingNotes,
  selectedCompanyIds,
  loading
}) => {
  return (
    <div className="action-toolbar" role="toolbar" aria-label="Data management actions">
      <div className="secondary-actions">
        <Button
          variant="primary"
          onClick={onExportNotes}
          disabled={selectedCompanyIds.size === 0 || exportingNotes}
        >
          {exportingNotes ? (
            <>
              <Spinner
                as="span"
                animation="border"
                size="sm"
                aria-hidden="true"
              />
              <output className="ms-2">Exporting...</output>
            </>
          ) : (
            'Export Notes'
          )}
        </Button>
        
        <Button
          variant="secondary"
          onClick={onEdit}
          disabled={selectedCompanyIds.size === 0}
        >
          Edit
        </Button>
      </div>
    </div>
  );
};

ActionToolbar.propTypes = {
  onExportNotes: PropTypes.func.isRequired,
  onEdit: PropTypes.func.isRequired,
  exportingNotes: PropTypes.bool.isRequired,
  selectedCompanyIds: PropTypes.instanceOf(Set).isRequired,
  loading: PropTypes.bool.isRequired
};

export default ActionToolbar; 